// import { getTenantLogoBySubdomain } from "@/services/auth";
import { setUserContext } from "@/store/auth/reducer";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "@/store";
import img from "@/assets/img/theme/no-image.png";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { formSchema } from "../../shared/schemas/loginFormSchema";
import { LoginFormModel } from "../../shared/models/models";
import { setLoader, showNotification } from "@/store/app/reducer";
import { getSubdomain } from "@/common/utils/utils";
import { withContext } from "@/common/utils/withContext";
import { useTranslation } from "react-i18next";
import { UpdatedUserRole, UserAccessRole } from "@/common/enums/enums";
import {
  CLIENT_URL,
  REACT_AUTH_ENDPOINT,
  XSM_BASE_URL,
  XSM_APPLICATION,
  XSM_DOMAIN,
  XSM_ORIGIN,
} from "@/common/constants/auth";
import { useAuth } from "../common/useAuth";
import CommonLogin from "../CommonLogin";
import { Loader } from "@/common/components/atoms/loader/loader";
import { IAppContextModel } from "@/store/app/types";
import { dispatchAuthLoginEvent } from "@/common/utils/componentListService";
import { getOAuthErrorMessageFromResponseUrl } from "../../utils/oauthPostAuthErrorMessage";

const SignInXSM = () => {
  const [state, setStateData] = useState({
    isVisible: false,
    tenantLogo: img,
    isLoadingSession: false,
  });
  const { t: translate } = useTranslation();
  const { control, formState, watch, getValues, trigger } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: new LoginFormModel(),
    mode: "onTouched",
  });

  const navigate = useNavigate();
  const subdomain = getSubdomain();
  const {
    initialAuthorization,
    sessionKey,
    isLoading: authLoading,
  } = useAuth();
  const appContext: IAppContextModel = useSelector(
    (state: any) => state.appContext
  );
  const [formDisabled, setFormDisabled] = useState(false);

  // const { refetch: fetchTenantLogo } = useQuery(
  //   "tenantLogo",
  //   () => {
  //     if (subdomain) {
  //       return getTenantLogoBySubdomain(subdomain);
  //     }
  //   },
  //   {
  //     keepPreviousData: true,
  //     refetchOnWindowFocus: false,
  //     enabled: false,
  //     onSuccess: async (data: any) => {
  //       if (data) {
  //         if (data?.status >= 400 && data?.status < 500) {
  //           setStateData((currentData: any) => {
  //             return {
  //               ...currentData,
  //               tenantLogo: img,
  //             };
  //           });
  //         } else if (data) {
  //           const base64String = await blobToBase64String(data);
  //           setStateData((currentData) => {
  //             return {
  //               ...currentData,
  //               tenantLogo: base64String,
  //             };
  //           });
  //         }
  //       }
  //     },
  //   }
  // );

  const handleClickShowPassword = () => {
    setStateData((currentData) => {
      return {
        ...currentData,
        isVisible: !currentData.isVisible,
      };
    });
  };

  // const onLogin = () => {
  //   const loginForm = getValues();
  //   loginUser(loginForm.userName, loginForm.password).then((res: any) => {
  //     if (res.status === 404) {
  //       store.dispatch(
  //         showNotification({
  //           showNotification: true,
  //           message: `${translate("authentication.wrong_email_or_password")}`,
  //           type: "error",
  //         })
  //       );
  //       return;
  //     }

  //     switch (res.status) {
  //       // Wrong email or password
  //       case StatusCodes.NOT_FOUND:
  //         props.notificationService?.notify({
  //           message: translate("authentication.wrong_email_or_password"),
  //           type: "error",
  //         });
  //         break;
  //       // Account is locked
  //       case HTTPError.USER_ACCOUNT_LOCKED_ERROR:
  //         props.notificationService?.notify({
  //           message: translate("authentication.account_locked"),
  //           type: "error",
  //         });
  //         break;
  //       // Account is inactive
  //       case HTTPError.USER_ACCOUNT_INACTIVE_ERROR:
  //         props.notificationService?.notify({
  //           message: translate("authentication.account_inactive"),
  //           type: "error",
  //         });
  //         break;
  //       // Account Suspended
  //       case HTTPError.USER_ACCOUNT_BLOCKED_ERROR:
  //         props.notificationService?.notify({
  //           message: translate("authentication.account_suspended"),
  //           type: "error",
  //         });
  //         break;
  //       // API User
  //       case HTTPError.TECHNICAL_USER_CANNOT_LOG_TO_UI_ERROR:
  //         props.notificationService?.notify({
  //           message: translate(
  //             "authentication.technical_user_cannot_login_to_ui"
  //           ),
  //           type: "error",
  //         });
  //         break;
  //       // Account Pending
  //       case HTTPError.USER_ACCOUNT_PENDING_ERROR:
  //         // Pending Users from the Super Tenant should not be able to request an activation email
  //         if (subdomain?.length) {
  //           // Usual Users
  //           props.notificationService?.notify({
  //             message: translate("authentication.account_pending"),
  //             type: "warning",
  //           });
  //           // No Create and show dialog data
  //           props.dialogService?.showConfirm(
  //             {
  //               confirmType: "YES_NO",
  //               title: `${translate("authentication.verify_email_title")}`,
  //               description: translate(
  //                 "authentication.verify_email_resend_confirm"
  //               ),
  //             },
  //             (result) => {
  //               if (result === "YES") {
  //                 navigate({
  //                   pathname: "/verify-email",
  //                   search: `?Email=${loginForm.userName}`,
  //                 });
  //               }
  //             }
  //           );
  //         } else {
  //           // Super Admin Users
  //           props.notificationService?.notify({
  //             message: translate("authentication.super_user_account_pending"),
  //             type: "warning",
  //           });
  //         }
  //         break;
  //       default:
  //         handleHttpError(res, translate("general.unexpected_error_backend"));
  //     }

  //     const userInfo = parseAccessToken(res.token);

  //     // set to store
  //     dispatch(
  //       setUserContext({
  //         isAuthenticated: true,
  //         userInfo,
  //       })
  //     );

  //     // set to local TODO: move keys to constants
  //     localStorage.setItem("access_token", res.token);
  //     localStorage.setItem("user_info", JSON.stringify(userInfo));

  //     if (!subdomain) {
  //       navigate("/tenants");
  //     } else {
  //       navigate("/dashboard");
  //     }
  //   });
  // };

  const ensureSessionKey = async (): Promise<string> => {
    setStateData((prev) => ({ ...prev, isLoadingSession: true }));

    try {
      const newSessionKey = await initialAuthorization();
      return newSessionKey;
    } finally {
      setStateData((prev) => ({ ...prev, isLoadingSession: false }));
    }
  };

  const onLoginClicked = async () => {
    // Step 1: Validate the form
    const isFormValid = await trigger();
    if (!isFormValid) {
      store.dispatch(
        showNotification({
          showNotification: true,
          message: translate("authentication.please_fill_required_fields"),
          type: "error",
        })
      );
      return;
    }

    try {
      // Set Loader to true
      store.dispatch(setLoader(true));

      // Step 2: Ensure we have a session key (wait for initialization if needed)
      const currentSessionKey = await ensureSessionKey();

      const loginForm = getValues();
      setFormDisabled(true);

      if (currentSessionKey) {
        // Step 3: Call the POST API to authenticate with the obtained code
        const postData = new URLSearchParams();
        postData.append("usernameUserInput", loginForm.userName);
        postData.append("username", loginForm.userName);
        postData.append("password", loginForm.password);
        postData.append("sessionDataKey", currentSessionKey);

        const authResponse = await fetch(
          `${XSM_BASE_URL}/xsm-api/v1/proxy/commonauth`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Access-Control-Allow-Origin": "*",
              "Xsm-Domain": subdomain ?? XSM_DOMAIN,
              "Xsm-application": XSM_APPLICATION,
            },
            body: postData,
          }
        );

        // First check if the response is OK
        if (!authResponse.ok) {
          // EVES-4545 : Handle OAuth error messages from the response URL
          // Author: Abhishek Bharti
          // Date: 03/31/2026
          const oauthErrorMessage = getOAuthErrorMessageFromResponseUrl(
            authResponse.url,
            translate
          );
          if (oauthErrorMessage) {
            setFormDisabled(false);
            store.dispatch(setLoader(false));
            store.dispatch(
              showNotification({
                showNotification: true,
                message: oauthErrorMessage,
                type: "error",
              })
            );
            return;
          }
          const errorData = await authResponse.json();
          setFormDisabled(false);
          store.dispatch(setLoader(false));
          store.dispatch(
            showNotification({
              showNotification: true,
              message: errorData?.message,
              type: "error",
            })
          );
          return;
        } else {
          const codeurl = new URL(authResponse.url);
          const code = codeurl.searchParams.get("code");
          if (code) {
            // Step 4: Call the API to exchange the code for an access token
            const tokenResponse = await fetch(
              `${XSM_BASE_URL}/xsm-api/v1/proxy/oauth2/token`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "xsm-application": XSM_APPLICATION,
                  "Xsm-Domain": subdomain ?? XSM_DOMAIN,
                  "Xsm-iscompressed": "true",
                  "X-Original-Origin": XSM_ORIGIN,
                },
                body: new URLSearchParams({
                  client_id: CLIENT_URL,
                  grant_type: "authorization_code",
                  redirect_uri: REACT_AUTH_ENDPOINT,
                  code, // Use the accesscode obtained from Step 3
                }),
              }
            );

            // Assuming the access token is available in the response
            const tokenData = await tokenResponse.json();
            //XSM Token
            const token = tokenData.access_token;

            let userInfo: any = {};
            if (subdomain) {
              //FETCH DOMAIN
              const domainResponse = await fetchTenents(token);
              if (domainResponse && domainResponse?.dom_name) {
                //FETCH USER
                const userResponse = await fetchUser(
                  token,
                  domainResponse?.dom_name,
                  loginForm.userName
                );

                const { userData } = await mappingUser(
                  token,
                  userResponse,
                  false
                );
                const updatedUserInfo = {
                  ...userData,
                  userId: userData.id,
                  tenantId: userData.tenantID,
                  firstName: userData.firstName,
                  lastName: userData.name,
                };
                userInfo = { ...updatedUserInfo };
              }
            } else {
              // Super Tenant Admin User
              const { userData } = await mappingUser(
                token,
                {
                  user_name: loginForm.userName,
                  user_profile: {
                    tenantId: XSM_DOMAIN,
                  },
                },
                true
              );
              const updatedUserInfo = {
                ...userData,
                userId: userData?.id,
                tenantId: userData.tenantID,
                firstName: userData?.firstName,
                lastName: userData?.name,
              };
              userInfo = { ...updatedUserInfo };
            }
            store.dispatch(
              setUserContext({
                isAuthenticated: true,
                userInfo,
              })
            );
            // set to local TODO: move keys to constants
            localStorage.setItem("access_token", token); //eves
            // Saving Expiry Token
            const expiresInMs = tokenData.expires_in * 1000; // convert to milliseconds
            const expirationTime = Date.now() + expiresInMs;
            localStorage.setItem("expires_in", expirationTime.toString());

            localStorage.setItem("user_info", JSON.stringify(userInfo));
            localStorage.setItem(
              "refresh_token",
              tokenData?.refresh_token as string
            );

            // Notify HOC to fetch component list in background (does not block navigation)
            dispatchAuthLoginEvent();

            const access = userInfo?.scopes?.includes(
              `${"Dashboard"}:${"List"}`
            );
            const charginStationAccess = userInfo?.scopes?.includes(
              `${"ChargingStation"}:${"List"}`
            );

            setFormDisabled(false);
            store.dispatch(setLoader(false));

            if (access) {
              navigate("/dashboard");
            } else if (charginStationAccess) {
              navigate("/charging-stations");
            } else {
              navigate("/tenants");
            }
          } else {
            // EVES-4545 : Handle OAuth error messages from the response URL
            // Author: Abhishek Bharti
            // Date: 03/31/2026
            const oauthErrorMessage = getOAuthErrorMessageFromResponseUrl(
              authResponse.url,
              translate
            );
            setFormDisabled(false);
            store.dispatch(setLoader(false));
            store.dispatch(
              showNotification({
                showNotification: true,
                message:
                  oauthErrorMessage ??
                  translate("authentication.wrong_email_or_password"),
                type: "error",
              })
            );
            return;
          }
        }
      }
    } catch (error) {
      setFormDisabled(false);
      store.dispatch(setLoader(false));
    }
  };

  const mappingUser = async (
    token: string,
    userResponse: any,
    isAdmin: boolean
  ) => {
    const userPayload = isAdmin
      ? {
        role: UpdatedUserRole.SUPER_ADMIN,
        rolesACL: "superAdmin",
        email: userResponse?.user_name,
        tenantID: userResponse?.user_profile?.tenantId,
      }
      : {
        id: userResponse?.user_profile?.userId,
        status: userResponse?.status,
        name: `${userResponse?.first_name} ${userResponse?.last_name}`,
        mobile: userResponse?.mobile_number,
        email: userResponse?.user_name,
        firstName: userResponse?.first_name,
        tenantID: userResponse?.user_profile?.tenantId,
        tenantName: userResponse?.user_profile?.tenantName,
        tenantSubdomain: userResponse?.dom_name,
      };

    const mappedUserData = await fetchUserScopes(token, {
      user: userPayload,
    });

    return mappedUserData;
  };

  //EVES
  const fetchUserScopes = async (token: string, userData: any) => {
    try {
      const scopeResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/scope`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );
      const response = await scopeResponse.json();
      return response;
    } catch (error) {
      console.error("error", error);
    }
  };

  //XSM User
  const fetchUser = async (
    token: string,
    domainName: string,
    userName: string
  ) => {
    try {
      const userResponse = await fetch(
        `${XSM_BASE_URL}/xsm-api/v1/user?userName=${userName}&domainName=${domainName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "XSM-Domain": domainName,
            "XSM-Internal": "true",
            "X-Original-Origin": XSM_ORIGIN,
          },
        }
      );
      const response = await userResponse.json();
      const userData = response?.result?.users[0];

      // Check if userData exists before accessing properties
      if (!userData) {
        console.error("No user data found in response:", response);
        return {};
      }

      let roles = {};
      // Safely access organizations array
      if (userData.organizations && Array.isArray(userData.organizations)) {
        userData.organizations.map((orgn: any) => {
          if (orgn.application && Array.isArray(orgn.application)) {
            orgn.application.map((app: any) => {
              if (app.role && Array.isArray(app.role)) {
                app.role.map((userrole: any) => {
                  if (
                    [
                      UserAccessRole.ADMIN,
                      UserAccessRole.DEMO,
                      UserAccessRole.BASIC,
                      UserAccessRole.EV,
                      UserAccessRole.CPO_ADMIN,
                    ].includes(userrole?.name)
                  ) {
                    roles = { ...userrole };
                  }
                });
              }
            });
          }
        });
      }

      userData.roles = roles;
      return userData;
    } catch (error) {
      return {};
    }
  };

  //get domain by username

  //XSM Domain
  //NOTE: How to figure out how to pass the domain ?
  const fetchTenents = async (token: string) => {
    try {
      const domainResponse = await fetch(`${XSM_BASE_URL}/xsm-api/v1/domain`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "XSM-Domain": subdomain ?? XSM_DOMAIN,
          "XSM-Internal": "true",
          "X-Original-Origin": XSM_ORIGIN,
        },
      });
      const response = await domainResponse.json();
      const domainData = response?.result?.domains[0];
      return domainData;
    } catch (error) {
      console.error("error", error);
    }
  };

  const { errors, isValid } = formState;
  const isAgreementAccepted = watch("acceptAgreement");

  const canSubmitForm =
    isValid && isAgreementAccepted && !!sessionKey && !authLoading;

  // EVES-3952: Loader is updated during the login process
  // Author: Abhishek Bharti
  // Date: 03/11/2024
  return (
    <>
      <CommonLogin
        {...{
          state: {
            ...state,
          },
          control,
          errors,
          handleClickShowPassword,
          onLogin: onLoginClicked,
          canSubmitForm,
          isForgot: false,
          emailName: "userName",
          headLabel: "Welcome to EVES!",
          disabled: formDisabled || authLoading,
        }}
      />
      <Loader showLoader={appContext.showLoader} />
    </>
  );
};

export default withContext(SignInXSM);
